import { useNavigate, useLocation } from "react-router-dom";

// Smooth-scroll to an element on the current page (Lenis-aware).
export const scrollToId = (id, opts = {}) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: 0, duration: 1.4, ...opts });
  else el.scrollIntoView({ behavior: "smooth" });
};

// Navigate to a homepage section from anywhere (routes back to "/" if needed).
export const useSectionNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (id) => {
    if (location.pathname !== "/") navigate("/", { state: { scrollTo: id } });
    else scrollToId(id);
  };
};

// Route to the contact form pre-filled to reserve a spot for a gathering.
export const useReserve = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (gathering) => {
    window.__gaiaContactPrefill = `I'd like to reserve my space for the ${gathering.title}${
      gathering.date ? ` (${gathering.date})` : ""
    }.`;
    // Don't let the announcement popup interrupt a reservation.
    try { sessionStorage.setItem(`gaia_announce_${gathering.slug}`, "1"); } catch (e) {}
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: "contact" } });
      setTimeout(() => window.dispatchEvent(new Event("gaia:prefill-contact")), 500);
    } else {
      window.dispatchEvent(new Event("gaia:prefill-contact"));
      scrollToId("contact");
    }
  };
};
